import { render } from "./KioskSettingView.vue?vue&type=template&id=a273ea5e"
import script from "./KioskSettingView.vue?vue&type=script&lang=js"
export * from "./KioskSettingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__